// extracted by mini-css-extract-plugin
export default {"print-button":"policyHolderClaimDetails_print-button__g0DhO"};